<template>
    <div
        v-if="location"
        class="stage-group"
        :class="cClass">
        <div class="container">
            <div
                class="felt"
                :class="{ editing: editTime }">
                <div class="in-step text-center">
                    <template v-if="editTime">
                        <div class="inline-block">
                            <hts-form-date
                                v-model="currentTime"
                                :label="'Thời gian ' + label"
                                type="datetime"
                                class="inline-block w-[194px]"
                                :clearable="false"
                                @change="handleChangeTime" />
                            <p
                                v-if="hasError"
                                class="text-red-500">
                                <span class="travel-error">
                                    Thời gian nhập lỗi
                                </span>
                            </p>
                        </div>
                    </template>
                    <template v-else>
                        <div>
                            <p class="text-right font-bold">
                                {{ timeAtTime }}
                            </p>
                            <p class="text-right">
                                {{ timeAtDate }}
                            </p>
                        </div>
                    </template>
                </div>
                <div class="in-line" />
            </div>
            <div
                class="step-item"
                :class="stepClasses">
                <div class="step-circle">
                    <hts-icons
                        svg="empty"
                        color="black"
                        class="w-6 h-6 cursor-pointer" />
                </div>
                <div class="step-line step-line-start" />
                <div class="step-line step-line-end" />
                <img
                    v-if="showVehicle && locationOut"
                    class="step-vehicle"
                    :src="vehicleImg" >
            </div>
            <div class="right">
                <div class="in-step">
                    <div class="flex items-center flex-wrap gap-2 w-full">
                        <span class="font-bold max-w-[70%] overflow-hidden text-ellipsis whitespace-nowrap">
                            {{ label }} - {{ location?.locationName }}
                        </span>
                        <div class="relative">
                            <span class="absolute left-0 -translate-y-3 flex gap-1">
                                <hts-icons
                                    v-if="processAlertStatus === alertValue"
                                    svg="warning-sign"
                                    class="inline-block"
                                    color="red" />
                            </span>
                        </div>
                    </div>

                    <p>
                        {{ location?.address }}
                    </p>
                </div>
                <div class="in-line" />
                <div class="right" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const vehicleImg = ref('/assets/vehicle.png')

const { $dayjs, $formatters } = useNuxtApp()

const props = defineProps({
  label: {
    type: String,
    default: 'Khởi hành'
  },
  editTime: Boolean,
  showVehicle: Boolean,
  expanded: Boolean,
  travelStageIndex: Number,
  travelIndex: Number,
  timeAt: { type: [String, Number] as PropType<number | string | null> },
  timeAtEstimate: { type: [String, Number] as PropType<number | string | null> },
  timeAtActual: { type: [String, Number] as PropType<number | string | null> },
  timeAtActualEstimate: { type: [String, Number] as PropType<number | string | null> },
  timeAtParking: Boolean,
  location: Object,
  hasError: Boolean,
  errorMessage: String,
  processAlertStatus: Number,
  alertValue: {
    type: Number,
    default: 60
  }
})

const emits = defineEmits(['clickStep', 'update-time'])

const { editTime, timeAt, timeAtEstimate, timeAtActualEstimate, timeAtActual, timeAtParking, showVehicle, travelStageIndex, location } = toRefs(props)

const cShowVehicle = computed(() => !editTime.value && showVehicle.value)
const timeAtValue = computed(() => {
  if (timeAtActual?.value) {
    return timeAtActual.value
  }
  if (editTime.value) {
    return ''
  }
  if (timeAtActualEstimate?.value) {
    return timeAtActualEstimate.value
  }
  if (timeAtEstimate?.value) {
    return timeAtEstimate.value
  }
  return timeAt?.value
})
const timeAtTime = computed(() => {
  return $dayjs(timeAtValue?.value).format('HH:mm')
})
const timeAtDate = computed(() => {
  return $formatters.date(timeAtValue?.value)
})

const currentTime = ref<any>('')

onMounted(() => {
  if (timeAtValue.value) {
    currentTime.value = $formatters.datetime(timeAtValue.value, 'YYYY-MM-DD HH:mm')
  }
})
const locationOut = computed(() => !!timeAtActual?.value)
const locationDone = computed(() => locationOut.value && !showVehicle.value)
const stepClasses = computed(() => {
  return {
    'step-out': locationOut.value,
    'show-vehicle': cShowVehicle.value,
    'step-done': locationDone.value
  }
})
const cClass = computed(() => {
  return {
    done: locationOut.value
  }
})

const handleChangeTime = (val: any) => {
  emits('update-time', val)
}
</script>
